import React from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'

import { SIZES } from '~/common/globalStyles'
import { AvatarListUserFragment } from '~/common/types/graphql'
import Avatar from '~/views/components/ui/Avatar'
import Tooltip from '~/views/components/ui/Tooltip'

const CompactTooltip = styled(Tooltip)`
  .tooltip {
    max-width: 300px;
    padding: ${SIZES.xxs} ${SIZES.xs};
    line-height: 1.2;
    margin: 0 5px;
  }
`

interface Props {
  compact?: boolean
  users?: AvatarListUserFragment[]
  size?: string
  tooltipPlacement?: string
}

interface FragmentProps {
  user: AvatarListUserFragment
}

const AvatarList: FragC<FragmentProps, Props> = (props) => {
  const { users = [] } = props
  const TooltipComponent = props.compact ? CompactTooltip : Tooltip
  const size = props.compact ? '29px' : '50px'
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {users.map((user, index) => {
        const marginLeft = index > 0 ? '-10px' : 0
        return (
          user && (
            <TooltipComponent
              key={user.id}
              title={`${user.firstName || user.email} ${user.lastName || ''}, ${
                user.jobRole || 'N/A'
              }`}
              placement={props.tooltipPlacement || 'top'}
            >
              <Avatar
                name1={user.firstName as string}
                name2={user.lastName as string}
                imageUrl={user.avatar?.originalUrl as string}
                size={props.size || size}
                style={{
                  marginLeft,
                  boxShadow: `1px 1px 5px rgba(0,0,0,.1)`,
                }}
              />
            </TooltipComponent>
          )
        )
      })}
    </div>
  )
}

Avatar.defaultProps = {
  name1: '',
  name2: '',
  imageUrl: '',
  size: SIZES.xxxl,
}

AvatarList.fragments = {
  user: gql`
    fragment AvatarList_User on UserType {
      id
      firstName
      lastName
      email
      jobRole
      ...Avatar_User
    }
    ${Avatar.fragments.user}
  `,
}

export default AvatarList
